import React from 'react';
import styled from 'styled-components';
import {
  ApolloClient,
  ApolloProvider,
  defaultDataIdFromObject,
  InMemoryCache,
} from '@apollo/client';
import { RestLink } from 'apollo-link-rest';
import env from 'bench-environment';
import PeerReviewStatus from './PeerReviewStatus';

const Wrapper = styled.div`
  padding: 0 0 1em 1em;
`;

type AppProps = {
  clientId: string;
};

const link = new RestLink({
  uri: `${env.location.apiRoot}/api/v1/`,
  credentials: 'include',
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});

const client = new ApolloClient({
  link,
  cache: new InMemoryCache({
    dataIdFromObject: object => defaultDataIdFromObject(object),
  }),
});

const App = ({ clientId }: AppProps) => {
  return (
    <ApolloProvider client={client}>
      <Wrapper>
        <PeerReviewStatus clientId={clientId} />
      </Wrapper>
    </ApolloProvider>
  );
};

export default App;
